import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

export const CountUp = ({ value, duration = 1.6, className = "", ...props }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [display, setDisplay] = useState(0);
  const match = String(value).match(/^([^0-9]*)(\d+)(.*)$/);

  useEffect(() => {
    if (!inView || !match) return;
    const target = parseInt(match[2], 10);
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / (duration * 1000));
      setDisplay(Math.round((1 - Math.pow(1 - p, 3)) * target));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, duration, match?.[2]]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!match) {
    return (
      <span ref={ref} className={className} {...props}>
        {value}
      </span>
    );
  }

  return (
    <span ref={ref} className={`tabular-nums ${className}`} {...props}>
      {match[1]}
      {display}
      {match[3]}
    </span>
  );
};
